import {Provider} from '@angular/core';
import {appInitializer} from '@app/app-initializer';
import {APP_ENVIRONMENT} from '@app/core/tokens/app-environment.token';

import {
  DatasetsService,
  DebugService,
  IrbProtocolsService,
  KeywordsService,
  LabelsService,
  OrganizationsService,
  ProjectsService,
  StatusService,
  SystemUsageReportService,
  UsersService,
  VariablesMeasuredService,
} from '@backend';
import {environment} from '@environments/environment';
import {
  CategoryService,
  EmailService,
  IconService,
  IndexService,
  LabelService,
  LoginService,
  MediaService,
  OrganizationService,
  PublicDatasetFileService,
  ResourceService,
  UiConfigService,
  UserService,
} from '@middleware';

export const provideBackendServices = (): Provider[] => {
  return [
    DatasetsService,
    DebugService,
    IrbProtocolsService,
    KeywordsService,
    LabelsService,
    OrganizationsService,
    ProjectsService,
    StatusService,
    SystemUsageReportService,
    UsersService,
    VariablesMeasuredService,
  ];
};

export const provideMiddlewareServices = (): Provider[] => {
  return [
    CategoryService,
    EmailService,
    IconService,
    IndexService,
    LabelService,
    LoginService,
    MediaService,
    OrganizationService,
    PublicDatasetFileService,
    ResourceService,
    StatusService,
    SystemUsageReportService,
    UiConfigService,
    UserService,
    {provide: APP_ENVIRONMENT, useValue: environment},
    {
      provide: appInitializer,
      useFactory: appInitializer,
      deps: [UiConfigService, APP_ENVIRONMENT],
      multi: true,
    },
  ];
};
